import intervalExecuter from './interval-executer';
import { loadScript } from 'ava-util/dist/loader';
import { message } from 'antd';
import site from 'pro/config/site';
import { COOKIE_COUNTRY, COOKIE_CURRENCY, COOKIE_LANG } from 'base/config/constant'
import { getCookie } from 'ava-util/dist/cookie';

declare const window: any;

export const ZENDESK_SCRIPT_ID = 'ze-snippet';
export const ZENDESK_SCRIPT_SRC = site.zenDesk.scriptSrc;

const MESSAGE_KEY = 'loading';
const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

const openStatus = {
    // Displays the widget on the host page in the state it was in before it was hidden. The widget is displayed by default on page load. You don't need to call show to display the widget unless you use hide.
    show: 'show',
    // Hides all parts of the widget from the page. You can invoke it before or after page load.
    hide: 'hide',
    // Opens the messaging Web Widget.
    open: 'open',
    // Closes the messaging Web Widget.
    close: 'close',
}

function open() {
    const zE = window.zE || {}
    if (zE.version) {
        setTimeout(() => {
            // 等待初始化 延迟打开
            message.destroy(MESSAGE_KEY);
            toggleMessaging('open')
        }, 100)
        return false;
    }
    message.open({
        key: MESSAGE_KEY,
        duration: 60000,
        type: 'loading',
        content: 'Loading...',
        style: {
            marginTop: '20vh'
        },
    });
    return true;
};

const executer = intervalExecuter(open, 200);

const toggleMessaging = (type?: 'open' | 'close') => {
    const zE = window.zE
    if (!zE) {
        return
    }
    const _openType = type
        || (zE?.customStatus === openStatus.open
            ? openStatus.close
            : openStatus.open)
    zE('messenger', openStatus[_openType]);
    // zE.customStatus = openStatus[_openType];
}


/**
 * 打标签和自定义字段
 * @param zE
 */
const handleTagsAndFields = (zE: any) => {
    const lang = getCookie(COOKIE_LANG);
    const country = getCookie(COOKIE_COUNTRY);
    const currency = getCookie(COOKIE_CURRENCY);

    const terminal = process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 'H5' : 'PC'
    // 平台标签
    zE('messenger:set', 'conversationTags', [terminal]);
    // 网站locale信息
    zE('messenger:set', 'conversationFields', [
        { id: '33016929757972', value: lang, },
        { id: '33016704818580', value: country, },
        { id: '33016930766100', value: currency },
    ]);
}

const onZEEvent = () => {
    const zE = window.zE;
    if (zE) {
        // 打开回调
        zE("messenger:on", "open", function () {
            const freshZE = window.zE;
            freshZE.customStatus = openStatus.open


            handleTagsAndFields(zE)
        })
        // 关闭回调
        zE("messenger:on", "close", function () {
            const freshZE = window.zE;
            freshZE.customStatus = openStatus.close
        })
    }
}

export function onZendeskLoad() {

    const zE = window.zE;
    if (zE) {
        const lang = getCookie(COOKIE_LANG);
        zE("messenger:set", "locale", lang || 'en');
        onZEEvent();
        handleTagsAndFields(zE);
        if (isPhone) {
            // zE('messenger', 'hide');
        }
    }
}

export function openZendesk() {
    if (document.getElementById(ZENDESK_SCRIPT_ID)) {
        executer.start();
    } else {
        loadScript(ZENDESK_SCRIPT_SRC, {
            id: ZENDESK_SCRIPT_ID
        }).then(() => {
            onZendeskLoad();
            executer.start();
        });
    }
}

export function toggleZendesk() {
    if (window.zE) {
        toggleMessaging()
    } else {
        openZendesk();
    }
}